import { useCompany } from "@/entities/company/hooks/use-company";
import { EntityNotFoundError } from "@/shared/lib/errors/404-not-found-error";

export const useCompanyId = () => {
  const company = useCompany();

  if (!company) {
    // beforeLoad should prevent this, but defensive fallback
    throw new EntityNotFoundError("Company");
  }

  return company.id;
};
